import { Link } from 'react-router-dom';
import React from 'react';

export default function TableLink({ to, children }) {
    const filters = location.search ? '?_filters=' + encodeURIComponent(location.search) : '';
    return <Link to={{ pathname: to, search: filters }}>{children}</Link>;
}
